import { render, staticRenderFns } from "./SettlementSummaryCard.vue?vue&type=template&id=2e43eb28&scoped=true&lang=pug"
import script from "./SettlementSummaryCard.vue?vue&type=script&lang=ts"
export * from "./SettlementSummaryCard.vue?vue&type=script&lang=ts"
import style0 from "./SettlementSummaryCard.vue?vue&type=style&index=0&id=2e43eb28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e43eb28",
  null
  
)

export default component.exports